import classNames from 'classnames';
import { IconProps } from './types';
import { TrashCan as TrashCanIcon } from '@carbon/react/icons';

import style from './icons.module.scss';

const TrashCan = ({ className }: IconProps) => {
  return (
    <div className={classNames(style.background, style.trashCan, className)}>
      <TrashCanIcon
        size={32}
        className={classNames(style.icon, style.trashCan)}
      />
    </div>
  );
};

export default TrashCan;
